import { ToastVariant } from '@/constants/ToastVariant';
import type { DisplayToastEventBus, ToastOptions } from '@/types/ToastEvents';
import { DISPLAY_TOAST_EVENT } from '@/types/ToastEvents';
import type { Emitter } from 'mitt';
import mitt from 'mitt';

const toaster: Emitter<DisplayToastEventBus> = mitt();

type ToastFn = (options: string | ToastOptions) => void;

export function useToasts(): {
  successToast: ToastFn;
  warningToast: ToastFn;
  errorToast: ToastFn;
  toaster: Emitter<DisplayToastEventBus>;
} {
  const successToast: ToastFn = (options) => {
    const optsToUse = typeof options === 'string' ? { title: options } : options;

    toaster.emit(DISPLAY_TOAST_EVENT, {
      variant: ToastVariant.SUCCESS,
      options: optsToUse,
    });
  };

  const warningToast: ToastFn = (options) => {
    const optsToUse = typeof options === 'string' ? { title: options } : options;

    toaster.emit(DISPLAY_TOAST_EVENT, {
      variant: ToastVariant.WARNING,
      options: optsToUse,
    });
  };

  const errorToast: ToastFn = (options) => {
    const optsToUse = typeof options === 'string' ? { title: options } : options;

    toaster.emit(DISPLAY_TOAST_EVENT, {
      variant: ToastVariant.ERROR,
      options: optsToUse,
    });
  };

  return {
    successToast,
    warningToast,
    errorToast,
    toaster,
  };
}
